import Col from "react-bootstrap/Col";
import Input from "../../common/input/Input";
import { tourScenesSelector } from "../../../hooks/store/getters";
import { useAppStore } from "../../../hooks/store/useAppStore";
import { tourActiveSceneIndexSelector } from './../../../hooks/store/getters';

const HotspotSene = ({ hotspot, onChange, errorSceneIndex, errorName}) => {

    const tourScenes = useAppStore(tourScenesSelector);
    const activeSceneIndex = useAppStore(tourActiveSceneIndexSelector);
    
    const scenes = tourScenes.map(
        (s, idx) => ({label: s.name, value: idx})
    ).filter(
        (s, idx) => idx !== activeSceneIndex
    );

    return(
        <>
            <Col md={6} sm={12}>
                <Input
                    label="Name"
                    onChange={onChange}
                    value={hotspot.name}
                    name="name"
                    error={errorName}
                    
                />
            </Col> 
            <Col md={6} sm={12}>
                <Input type="select"
                    label="Select a Scene"
                    placeholder="Select scene"
                    name="sceneIndex"
                    options={scenes}
                    onChange={onChange}
                    value={hotspot.sceneIndex}
                    error={errorSceneIndex}
                />
            </Col>
        </>
    )

}

export default HotspotSene;